export const normalDateFormat = "EEEE, dd MMM yyyy";
export const shortDateFormat = "yyyy-MM-dd";
